var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fast Delivery "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9148 18.0003L22 18V13.8571L18.5 10H15V18M19.9148 18.0003C19.7089 17.4175 19.1532 17 18.5 17M19.9148 18.0003C19.97 18.1566 20 18.3248 20 18.5M18.5 17C17.8468 17 17.2911 17.4175 17.0852 18.0003M18.5 17C19.3284 17 20 17.6716 20 18.5M18.5 17C17.6716 17 17 17.6716 17 18.5M17.0852 18.0003L15 18M17.0852 18.0003C17.03 18.1566 17 18.3248 17 18.5M15 18V6H1M15 18L7.91475 18.0003M7.91475 18.0003C7.70891 17.4175 7.15322 17 6.5 17M7.91475 18.0003C7.96996 18.1566 8 18.3248 8 18.5M6.5 17C5.84678 17 5.29109 17.4175 5.08525 18.0003M6.5 17C7.32843 17 8 17.6716 8 18.5M6.5 17C5.67157 17 5 17.6716 5 18.5M5.08525 18.0003L4 18M5.08525 18.0003C5.03004 18.1566 5 18.3248 5 18.5M20 18.5C20 19.3284 19.3284 20 18.5 20C17.6716 20 17 19.3284 17 18.5M8 18.5C8 19.3284 7.32843 20 6.5 20C5.67157 20 5 19.3284 5 18.5M4.5 12H3M4.5 15H4M4.5 9H2",
    stroke: "black",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDelivery);
export default __webpack_public_path__ + "static/media/Fast_Delivery.a1355a13b88d5ad888cb0d4ac1396bd5.svg";
export { ForwardRef as ReactComponent };